import { render, staticRenderFns } from "./ScreenTranslucenciaNucalMorfologica1Trimestre.vue?vue&type=template&id=89d5f9fc&scoped=true&"
import script from "./ScreenTranslucenciaNucalMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalMorfologica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalMorfologica1Trimestre.vue?vue&type=style&index=0&id=89d5f9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d5f9fc",
  null
  
)

export default component.exports